export const GA_TRACKING_ID = "G-3Y51H1RYLW";

// Track pageviews
export const pageview = (url: string) => {
  if (typeof window !== "undefined") {
    (window as any).gtag("config", GA_TRACKING_ID, {
      page_path: url,
    });
  }
};

// Optional: track custom events
interface GTagEvent {
  action: string;
  category: string;
  label: string;
  value?: number;
}

export const event = ({ action, category, label, value }: GTagEvent) => {
  if (typeof window !== "undefined") {
    (window as any).gtag("event", action, {
      event_category: category,
      event_label: label,
      value,
    });
  }
};
